import { render, staticRenderFns } from "./SetExtraIngredientsStep.vue?vue&type=template&id=6056e158&scoped=true&"
import script from "./SetExtraIngredientsStep.vue?vue&type=script&lang=js&"
export * from "./SetExtraIngredientsStep.vue?vue&type=script&lang=js&"
import style0 from "./SetExtraIngredientsStep.vue?vue&type=style&index=0&id=6056e158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056e158",
  null
  
)

export default component.exports